<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
        <md-card class="search-area">
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>search</md-icon>
              검색조건
            </h4>
          </md-card-header>
          <md-card-content>
            <table class="flex-table">
              <tr>
                <th>대상학기</th>
                <td>
                  <div class="inline-flex">
                    <select v-model="semesterCd" name="semesterCd">
                      <option value="">선택</option>
                      <option v-for="item in semesterCdList" :key="item.code" :label="item.codeNm" :value="item.code">
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </td>

                  <md-button class="md-info md-sm" @click="searchQuery" style="margin-left: 5px;">
                    <md-icon>check</md-icon>검색
                  </md-button>
                <td colspan="3" style="visibility: hidden; border:none;"></td>
              </tr>
            </table>

          </md-card-content>
        </md-card>
        <md-card>
          <md-card-header
            style="display: flex; justify-content: space-between; align-items: center;"
          >
            <h4 class="title" style="margin: 0; display: flex; align-items: center;">
              <md-icon>list</md-icon>
              검색 결과
            </h4>
            <md-button class="md-info md-sm" @click="downloadExcel" style="display: flex; align-items: center;">
              <md-icon>file_download</md-icon>엑셀 다운로드
            </md-button>
          </md-card-header>
          <md-card-content>
            <md-table :value="schaDataList" class="paginated-table table-striped table-hover text-align-center h-scroll h720">
              <md-table-row slot="md-table-row" slot-scope="{ item }" :rowspan="2">
                <md-table-cell md-label="구분" v-bind:class="{sumary1: isSumary1(item.college), sumary2: isSumary2(item.college), sumary3: isSumary3(item.applyGbNm), sumary4: isSumary4(item.applyGbNm)}" style="font-weight: bold;">{{ item.applyGbNm }}</md-table-cell>
                <md-table-cell md-label="캠퍼스구분" v-bind:class="{sumary1: isSumary1(item.college), sumary2: isSumary2(item.college), sumary3: isSumary3(item.applyGbNm), sumary4: isSumary4(item.applyGbNm)}">{{ item.campus }}</md-table-cell>
                <md-table-cell md-label="통합단과대" v-bind:class="{sumary1: isSumary1(item.college), sumary2: isSumary2(item.college), sumary3: isSumary3(item.applyGbNm), sumary4: isSumary4(item.applyGbNm)}" style="text-align: left; border-right: 2px solid red !important;">{{ item.college }}</md-table-cell>
                <md-table-cell md-label="장학회:금액(A+B)" v-bind:class="{sumary1: isSumary1(item.college), sumary2: isSumary2(item.college), sumary3: isSumary3(item.applyGbNm), sumary4: isSumary4(item.applyGbNm)}" style="text-align: right; font-weight: bold;">{{ formatter.getCurrency(item.totScha) }}</md-table-cell>
                <md-table-cell md-label="장학회:인원" v-bind:class="{sumary1: isSumary1(item.college), sumary2: isSumary2(item.college), sumary3: isSumary3(item.applyGbNm), sumary4: isSumary4(item.applyGbNm)}" style="text-align: right;">{{ formatter.getCurrency(item.cntScha) }}</md-table-cell>
                <md-table-cell md-label="장학회목적사업비(A)" v-bind:class="{sumary1: isSumary1(item.college), sumary2: isSumary2(item.college), sumary3: isSumary3(item.applyGbNm), sumary4: isSumary4(item.applyGbNm)}" style="text-align: right;">{{ formatter.getCurrency(item.schaA) }}</md-table-cell>
                <md-table-cell md-label="장학회기본재산(B)" v-bind:class="{sumary1: isSumary1(item.college), sumary2: isSumary2(item.college), sumary3: isSumary3(item.applyGbNm), sumary4: isSumary4(item.applyGbNm)}" style="text-align: right;  border-right: 2px solid blue !important;">{{ formatter.getCurrency(item.schaB) }}</md-table-cell>
                <md-table-cell md-label="교우회:금액(A+B+C+D)" v-bind:class="{sumary1: isSumary1(item.college), sumary2: isSumary2(item.college), sumary3: isSumary3(item.applyGbNm), sumary4: isSumary4(item.applyGbNm)}" style="text-align: right; font-weight: bold;">{{ formatter.getCurrency(item.totKuaa) }}</md-table-cell>
                <md-table-cell md-label="교우회:인원" v-bind:class="{sumary1: isSumary1(item.college), sumary2: isSumary2(item.college), sumary3: isSumary3(item.applyGbNm), sumary4: isSumary4(item.applyGbNm)}" style="text-align: right;">{{ formatter.getCurrency(item.cntKuaa) }}</md-table-cell>
                <md-table-cell md-label="교우회:기부자실입금" v-bind:class="{sumary1: isSumary1(item.college), sumary2: isSumary2(item.college), sumary3: isSumary3(item.applyGbNm), sumary4: isSumary4(item.applyGbNm)}" style="text-align: right;">{{ formatter.getCurrency(item.kuaaA) }}</md-table-cell>
                <md-table-cell md-label="교우회:학생직접입금" v-bind:class="{sumary1: isSumary1(item.college), sumary2: isSumary2(item.college), sumary3: isSumary3(item.applyGbNm), sumary4: isSumary4(item.applyGbNm)}" style="text-align: right;">{{ formatter.getCurrency(item.kuaaB) }}</md-table-cell>
                <md-table-cell md-label="교우회:연계지급" v-bind:class="{sumary1: isSumary1(item.college), sumary2: isSumary2(item.college), sumary3: isSumary3(item.applyGbNm), sumary4: isSumary4(item.applyGbNm)}" style="text-align: right;">{{ formatter.getCurrency(item.kuaaC) }}</md-table-cell>
                <md-table-cell md-label="교우회:기금" v-bind:class="{sumary1: isSumary1(item.college), sumary2: isSumary2(item.college), sumary3: isSumary3(item.applyGbNm), sumary4: isSumary4(item.applyGbNm)}" style="text-align: right;">{{ formatter.getCurrency(item.kuaaD) }}</md-table-cell>
                <md-table-cell md-label="교우회:보전액" v-bind:class="{sumary1: isSumary1(item.college), sumary2: isSumary2(item.college), sumary3: isSumary3(item.applyGbNm), sumary4: isSumary4(item.applyGbNm)}" style="text-align: right; border-right: 2px solid red !important;">{{ formatter.getCurrency(item.kuaaE) }}</md-table-cell>
                <md-table-cell md-label="합계:금액" v-bind:class="{sumary1: isSumary1(item.college), sumary2: isSumary2(item.college), sumary3: isSumary3(item.applyGbNm), sumary4: isSumary4(item.applyGbNm)}" style="font-weight: bold; text-align: right;">{{ formatter.getCurrency(item.totAmount) }}</md-table-cell>
                <md-table-cell md-label="합계:인원수" v-bind:class="{sumary1: isSumary1(item.college), sumary2: isSumary2(item.college), sumary3: isSumary3(item.applyGbNm), sumary4: isSumary4(item.applyGbNm)}" style="font-weight: bold; text-align: right;">{{ formatter.getCurrency(item.totCnt) }}</md-table-cell>
                <md-table-cell hidden></md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
  </div>

</template>

<script>

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import formatter from "@/kuaa/kuaa-formatter";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";


export default {

  components: {

  },

  created() {
    this.getSemesterCdList();
  },

  data(){
    return {
      formatter,
      semesterCdList: null,
      schaDataList: null,
      semesterCd:''
    }
  },

  methods: {
    
    downloadExcel() {
      if (!this.schaDataList || this.schaDataList.length === 0) {
        kuaaFnc.showSwal("엑셀 다운로드", "다운로드할 데이터가 없습니다.");
        return;
      }
      // 원하는 컬럼만 추출
      const excelData = this.schaDataList.map(item => ({
        "구분": item.applyGbNm,
        "캠퍼스구분": item.campus,
        "통합단과대": item.college,
        "장학회:금액(A+B)": item.totScha,
        "장학회:인원": item.cntScha,
        "장학회목적사업비(A)": item.schaA,
        "장학회기본재산(B)": item.schaB,
        "교우회:금액(A+B+C+D)": item.totKuaa,
        "교우회:인원": item.cntKuaa,
        "교우회:기부자실입금": item.kuaaA,
        "교우회:학생직접입금": item.kuaaB,
        "교우회:연계지급": item.kuaaC,
        "교우회:기금": item.kuaaD,
        "교우회:보전액": item.kuaaE,
        "합계:금액": item.totAmount,
        "합계:인원수": item.totCnt
      }));

        const selectedSemester = this.semesterCdList
          ? this.semesterCdList.find(item => item.code === this.semesterCd)
          : null;
        const semesterName = selectedSemester ? selectedSemester.codeNm : '';

      const ws = XLSX.utils.json_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "장학통계");

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const fileName = `장학통계_${semesterName ? semesterName + '_' : ''}${this.semesterCd}.xlsx`;
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName);
    },

    getSemesterCdList (){
      kuaaFnc.fncSemesterCodes(null,res => {
        this.semesterCdList = res.data.data.contents;
      });
    },

    searchQuery: function () {

      if (!this.semesterCd) {
        kuaaFnc.showSwal("장학 통계", '학기구분은 필수 조회 조건입니다.');
        return false;
      }


      kuaaApi.sendServer(
          URL_CONST.GET_STATISTICS_SCHA_LIST,
          {semesterCd: this.semesterCd},
          "post",
          (response) => {

            this.schaDataList = [...response.data.data.contents.dataList, ...response.data.data.contents.sumTotList];
            //}
          }
      );
    },

    isSumary1(data){
      if(data == '계')   return true;
    },
    isSumary2(data){
      if(data == '소계')   return true;
    },

    isSumary3(data){
      if(data == '합계')   return true;
    },
    isSumary4(data){
      if(data == '총합계')   return true;
    }
  }
}
</script>

<style>
  .sumary1{
    background-color: #d3efd6;  /*#00acc1;*/
    font-weight: bold;
    text-align: center;
  }
  .sumary2{
    background-color: #a8c4aa;  /*#00acc1;*/
    font-weight: bold;
  }
  .sumary3{
    background-color: #81c784;  /*#00acc1;*/
    font-weight: bold;
  }
  .sumary4{
    background-color: #9c81c7;  /*#00acc1;*/
    font-weight: bold;
  }
</style>